import { render } from "./order-new.vue?vue&type=template&id=917aa36e&scoped=true"
import script from "./order-new.vue?vue&type=script&lang=js"
export * from "./order-new.vue?vue&type=script&lang=js"

import "./order-new.vue?vue&type=style&index=0&id=917aa36e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917aa36e"]])

export default __exports__